// extracted by mini-css-extract-plugin
export var item = "F_P";
export var ros = "F_b1";